import type { z } from 'zod'
import type { fileTypeSchema } from '@/validations/schemas'
import { TableAttachment } from './tableAttachment'
import { WorkflowDialogAddAttachment } from './workflowDialogAddAttachment'

export type LocalAttachment = z.infer<typeof fileTypeSchema> & {
  s3Key?: string
  fileType?: string
  originalName?: string
  size?: number
  responsible?: {
    id: string
    name: string
    image: string
    area: string
  }
  createdAt?: string
}

type WorkflowAttachmentProps = {
  stepName: string
  attachments: LocalAttachment[]
  onAddAttachments: (files: LocalAttachment[]) => void
  onRemoveAttachment: (index: number) => void
}

export function WorkflowAttachment({
  stepName,
  attachments,
  onAddAttachments,
  onRemoveAttachment,
}: WorkflowAttachmentProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <span className="text-base font-medium text-system-text-primary">
          Anexos
        </span>
        <WorkflowDialogAddAttachment
          stepName={stepName}
          onAddAttachments={onAddAttachments}
        />
      </div>

      <TableAttachment
        attachments={attachments}
        onRemoveAttachment={onRemoveAttachment}
      />
    </div>
  )
}
